import { render, staticRenderFns } from "./BettingResults.vue?vue&type=template&id=5b75eeff&scoped=true&"
import script from "./BettingResults.vue?vue&type=script&lang=js&"
export * from "./BettingResults.vue?vue&type=script&lang=js&"
import style0 from "./BettingResults.vue?vue&type=style&index=0&id=5b75eeff&scoped=true&lang=css&"
import style1 from "./BettingResults.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b75eeff",
  null
  
)

export default component.exports